import ApiService from "@/common/api.service";
import {getUserToken, setExpirationTime, setUser, setUserToken} from "../utils/helper";
import {CHECK_AUTH, LOGIN, LOGOUT} from "./actions.type";
import {PURGE_AUTH, SET_AUTH, SET_ERROR} from "./mutations.type";

const applyReadOnlyPermissions = (user) => {
    if (!user?.data?.readOnly) {
        return user;
    }

    const stripWritePermissions = (permissions = []) =>
        Array.isArray(permissions)
            ? permissions.map((permission) => ({
                ...permission,
                canCreate: false,
                canUpdate: false,
                canAccreditCourse: false,
            }))
            : [];

    user.permissions = stripWritePermissions(user.permissions);

    if (user?.data?.userRoles?.role_menu_permissions) {
        user.data.userRoles.role_menu_permissions = stripWritePermissions(
            user.data.userRoles.role_menu_permissions
        );
    }

    return user;
};

const state = {
    errors: null,
    user: {},
    isAuthenticated: !!(getUserToken())
};

const getters = {
    currentUser(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    },
    hasError(state) {
        return state.errors;
    }
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("/user/login", credentials)
                .then(({data}) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(() => {
                    context.commit(SET_ERROR, [{
                        message: "Incorrect Username or Password"
                    }]);
                    reject()
                });
        });
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH);
    },
    [CHECK_AUTH](context) {
        if (getUserToken()) {
            ApiService.setHeader();
        } else {
            context.commit(PURGE_AUTH);
        }
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.user = user;
        let permissions = user.data.userRoles.role_menu_permissions
        user.permissions = permissions;
        applyReadOnlyPermissions(user);
        state.errors = {};
        setUserToken(user.token);
        setExpirationTime(user.data.expirationTime);
        setUser(user)
        ApiService.setHeader();
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
